module.exports = __webpack_public_path__ + "img/add.e13edc76.jpg";